import { BrowserRouter, Navigate, Route } from "react-router-dom";
import RoutesWithNotFound from "../util/routesWithNotFound";
import { RutasPrivadas } from "./rutasPrivadas/rutasPrivadas";
import AuthGuard from "../guards/auth.guard";
import { InicioSesionScreen } from "../components/pages/InicioSesionScreen";
import { Private } from "../components/pages/Private";
import { VCardScreen } from "../components/pages/VCardScreen";

const AppRouter = () => {
	return (
		<div>
			<BrowserRouter>
				<div>
					<RoutesWithNotFound>
						<Route path="/" element={<Navigate to={RutasPrivadas.HOME} />} />
						<Route path="/login" element={<InicioSesionScreen />} />
						<Route path="/vcard" element={<VCardScreen />}></Route>
						<Route element={<AuthGuard privateValidation={true} />}>
							<Route path={`${RutasPrivadas.PRIVATE}/*`} element={<Private />} />
						</Route>
					</RoutesWithNotFound>
				</div>
			</BrowserRouter>
		</div>
	)
};

export default AppRouter;
